import { AddBox, Cancel, Delete, Edit, Schedule } from "@mui/icons-material";
import { Alert, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormLabel, Modal, Paper, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react"
import axiosInstance from "../../../utils/axiosInstance";

const Instructors = () => {
    const [instructors, setInstructors] = useState([
        {
            instructor_id: 0,
            name: '',
            email: '',
            phone: '',
            speciality: '',
            avialability: '',
            hourly_rate: '',
            image_url: '',
            bio: '',
            instagram: '',
            facebook: '',
            twitter: '',
            whatsapp: '',
            createdAt: '',
        }
    ]);

    const [instructor, setInstructor] = useState({
        instructor_id: 0,
        name: '',
        email: '',
        phone: '',
        speciality: '',
        avialability: '',
        hourly_rate: '',
        image_url: '',
        bio: '',
        instagram: '',
        facebook: '',
        twitter: '',
        whatsapp: '',
        password: '',
    })
    const [schedule, setSchedule] = useState({
        day: '',
        exercise: '',
        start_time: '',
        end_time: '',
        status: false
    })

    const [schedules, setSchedules] = useState([{
        schedule_id: '',
        day: '',
        exercise: '',
        start_time: '',
        end_time: '',
        status: false,
        createdAt: '',
    }])
    const [selectedSchedule, setSelectedSchedule] = useState({});
    const [selectedInstructor, setSelectedInstructor] = useState({});
    const [searchQuery, setSearchQuery] = useState("");
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [file, setFile] = useState({});
    const [isSchedulerOpen, setIsSchedulerOpen] = useState(false);
    const [isAddScheduleOpen, setIsAddScheduleOpen] = useState(false);
    const [isEditScheduleOpen, setIsEditScheduleOpen] = useState(false);
    const [isDeleteScheduleOpen, setIsDeleteScheduleOpen] = useState(false);
    const getInstructorsRef = useRef()

    const filteredInstructors = instructors.filter((user) =>
        user.name.toLowerCase().includes(searchQuery.toLowerCase()) || user.email.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const paginatedInstructors = filteredInstructors.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    // Pagination handlers
    const handleChangePage = (event, newPage) => {
        console.log(event)
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // Delete confirmation handlers
    const handleOpenDeleteModal = (user) => {
        setSelectedInstructor(user);
        setIsDeleteModalOpen(true);
    };

    const handleOpenEditModal = (user) => {
        setSelectedInstructor(user);
        setIsEditModalOpen(true);
    };

    const handleOpenScheduler = async (user) => {
        setIsSchedulerOpen(true);
        setSelectedInstructor(user);
        getSchedules(user.instructor_id)
    }

    const getSchedules = async (instructor_id) => {
        await axiosInstance.get(`instructors/getall/${instructor_id}`).then((response) => {
            setSchedules(response.data.data)
        }).catch((err) => {
            if(err.status === 404) {
                setSchedules([])
            } else {
                setSchedules([])
                // console.error(err.response.data);
            }
        })
    }

    const handleFileUpload = (e) => {
        setFile(e.target.files[0])
    }

    const handleAddInstructor = async() => {
        setOpen(true);

        const formData = new FormData();
        formData.append('name', instructor.name)
        formData.append('email', instructor.email)
        formData.append('phone', instructor.phone)
        formData.append('speciality', instructor.speciality)
        formData.append('avialability', instructor.avialability)
        formData.append('hourly_rate', instructor.hourly_rate)
        formData.append('bio', instructor.bio)
        formData.append('image_url', file)
        formData.append('instagram', instructor.instagram)
        formData.append('facebook', instructor.facebook)
        formData.append('twitter', instructor.twitter)
        formData.append('whatsapp', instructor.whatsapp)
        formData.append('password', instructor.password)

        await axiosInstance.post(`instructors/create`, formData).then((response) => {
            setMessage(`Success, successfully added ${instructor.name}`)
            setTimeout(() => {
                setOpen(false);
                if(getInstructorsRef.current) getInstructorsRef.current();
                setIsAddModalOpen(false)
            }, 2000)
        }).catch((error) => {
            if(error.response && error.response.data.error) {
                setMessage(`Failure, ${error.response.data.error}`)
            } else {
                setMessage(`Failure, ${error}`)
            }
            console.log(error.response.data)
            setTimeout(() => { setOpen(false)}, 2000);
        })
    }

    const handleEditInstructor = async() => {
        setOpen(true);

        await axiosInstance.put(`instructors/update/${selectedInstructor.instructor_id}`, selectedInstructor).then(() => {
            setMessage(`Success, successfully edited ${selectedInstructor.name}`)
            setTimeout(() => {
                setOpen(false);
                if(getInstructorsRef.current) getInstructorsRef.current();
                setIsEditModalOpen(false)
            }, 2000)
        }).catch((error) => {
            if(error.status === 404) {
                setMessage(`Failure, guest not found`)
            } else if(error.status === 400) {
                setMessage(`Failure, ${error.response.error}`)
            } else {
                setMessage(`Failure, ${error}`)
            }
            setTimeout(() => { setOpen(false)}, 2000)
        })
    }

    const handleDeleteUser = async () => {
        setOpen(true)
        
        await axiosInstance.delete(`instructors/delete/${selectedInstructor.instructor_id}`).then(() => {
            setMessage(`Success, successfully deleted ${selectedInstructor.name}`)
            setTimeout(() => {
                setOpen(false);
                if(getInstructorsRef.current) getInstructorsRef.current();
                setIsDeleteModalOpen(false)
            }, 2000)
        }).catch((error) => {
            if(error.status === 404) {
                setMessage("No instructor found")
            } else if(error.status === 400) {
                setMessage(error.response.error)
            } else {
                setMessage(error)
            }

            setTimeout(() => {
                setOpen(false)
            }, 2000)
        })
    }

    const handleEditScheduleOpener = (schedule) => {
        console.log(schedule)
        setIsEditScheduleOpen(true)
        setSelectedSchedule(schedule)
    }
    const handleDeleteScheduleOpener = (schedule) => {
        setIsDeleteScheduleOpen(true)
        setSelectedSchedule(schedule)
    }

    const handleAddToInstructorSchedule = async () => {
        setOpen(true);

        await axiosInstance.post(`instructors/create/${selectedInstructor.instructor_id}`, schedule, {
            headers: { 'Content-Type': 'application/json' }
        }).then(() => {
            setMessage(`Success, successfully added ${instructor.name}'s schedule`)
            setTimeout(() => {
                setOpen(false);
                getSchedules(selectedInstructor.instructor_id);
                setIsAddScheduleOpen(false)
            }, 2000)
        }).catch((error) => {
            if(error.response && error.response.data.error) {
                setMessage(`Failure, ${error.response.data.error}`)
            } else {
                setMessage(`Failure, ${error}`)
            }
            console.log(error.response.data)
            setTimeout(() => { setOpen(false)}, 2000);
        })
    }

    const handleEditToInstructorSchedule = async () => {
        setOpen(true);

        await axiosInstance.put(`instructors/edit/${selectedSchedule.schedule_id}`, selectedSchedule).then((response) => {
            setMessage(`Success, successfully edited ${selectedInstructor.name}'s schedule`)
            console.log(response.data.data)
            setTimeout(() => {
                setOpen(false);
                getSchedules(selectedInstructor.instructor_id);
                setIsEditScheduleOpen(false)
                setSelectedSchedule({})
            }, 2000)
        }).catch((error) => {
            if(error.response && error.response.data.error) {
                setMessage(`Failure, ${error.response.data.error}`)
            } else {
                setMessage(`Failure, ${error}`)
            }
            console.log(error.response.data)
            setTimeout(() => { setOpen(false)}, 2000);
        })
    }

    const handleDeleteSchedule = async () => {
        setOpen(true)
        
        await axiosInstance.delete(`instructors/delete_schedule/${selectedSchedule.schedule_id}`).then(() => {
            setMessage(`Success, successfully deleted ${selectedInstructor.name}'s schedule`);
            setTimeout(() => {
                setOpen(false);
                getSchedules(selectedInstructor.instructor_id);
                setIsDeleteScheduleOpen(false)
                setSelectedSchedule({})
            }, 2000)
        }).catch((error) => {
            if(error.status === 404) {
                setMessage("Schedule not found")
            } else if(error.status === 400) {
                setMessage(error.response.error)
            } else {
                setMessage(error)
            }

            setTimeout(() => {
                setOpen(false)
            }, 2000)
        })
    }

    useEffect(() => {
        const getInstructors = async () => {
            await axiosInstance.get(`instructors/all`).then((response) => {
                setInstructors(response.data.instructors);
            }).catch((error) => {
                if(error.response && error.response.data.message === "No instructors found") {
                    setInstructors([]);
                } else if(error.response && error.response.data.message !== "No instructors found") {
                    setInstructors([]);
                } else {
                    setInstructors([]);
                }
            });
        }

        getInstructors();
    }, [])

    return(
        <div>
            <div className="md:flex justify-between md:flex-wrap">
                <Typography variant='h4' className="text-blue-800">Manage instructors</Typography>
                <div className="mt-4 md:mt-0"><Button className="flex gap-3" variant="outlined" onClick={() => setIsAddModalOpen(true)}><AddBox /> Add Instructor</Button></div>
            </div>
            <br />

            <div className="p-4">
                <TextField label="Search for a instructor by name, email" variant="outlined" fullWidth value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
                <TableContainer component={Paper} className="shadow mt-4" sx={{ color: "#1f2937", overflowX: "auto" }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>Phone</TableCell>
                                <TableCell>Speciality</TableCell>
                                <TableCell>Bio</TableCell>
                                <TableCell>Avialability</TableCell>
                                <TableCell>Hourly rate</TableCell>
                                <TableCell>Instgram</TableCell>
                                <TableCell>Facebook</TableCell>
                                <TableCell>Twitter</TableCell>
                                <TableCell>whatsApp</TableCell>
                                <TableCell>Created At</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {paginatedInstructors.map((instructor, index) => (
                                <TableRow key={index}>
                                    <TableCell>{index+1}</TableCell>
                                    <TableCell>{instructor.name}</TableCell>
                                    <TableCell>{instructor.email}</TableCell>
                                    <TableCell>{instructor.phone}</TableCell>
                                    <TableCell>{instructor.speciality}</TableCell>
                                    <TableCell className="text-truncate">{instructor.bio}</TableCell>
                                    <TableCell>{instructor.avialability}</TableCell>
                                    <TableCell>{instructor.hourly_rate}</TableCell>
                                    <TableCell>{instructor.instagram}</TableCell>
                                    <TableCell>{instructor.facebook}</TableCell>
                                    <TableCell>{instructor.twitter}</TableCell>
                                    <TableCell>{instructor.whatsapp}</TableCell>
                                    <TableCell>{instructor.createdAt.slice(0, 10)}</TableCell>
                                    <TableCell className="flex gap-2">
                                        <Schedule color="success" className="cursor-pointer" onClick={() => handleOpenScheduler(instructor)} />
                                        <Edit color="primary" onClick={() => handleOpenEditModal(instructor)} className="cursor-pointer" />
                                        <Delete color="error" onClick={() => handleOpenDeleteModal(instructor)} className="cursor-pointer" />
                                    </TableCell>
                                </TableRow>
                            ))}
                            {filteredInstructors.length === 0 && <TableRow><TableCell colSpan={7} className="text-center">No user found.</TableCell></TableRow>}
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25, 50, filteredInstructors.length]}
                        component="div"
                        count={filteredInstructors.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </TableContainer>
            </div>

            {/* Delete Confirmation Modal */}
            <Dialog open={isDeleteModalOpen} onClose={() => setIsDeleteModalOpen(false)}>
                <DialogTitle className="text-blue-950">Delete Confirmation</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete the instructor named "
                        {selectedInstructor.name ? selectedInstructor.name : "Anonymus"}"?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsDeleteModalOpen(false)} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleDeleteUser} color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Edit Instructor Modal */}
            <Modal open={isEditModalOpen} onClose={() => setIsEditModalOpen(false)} className="flex justify-center items-center" aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div className='bg-white w-[90%] lg:w-[40%] shadow p-8 rounded-sm h-[90%] overflow-y-auto'>
                    <h2 className="text-blue-950 mb-8">Edit Instructor</h2>
                    <div>
                        <TextField variant="outlined" fullWidth value={selectedInstructor.name} onChange={(e) => setSelectedInstructor((prev) => ({ ...prev, name: e.target.value }))} type="text" label="Entet name of instructor" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={selectedInstructor.phone} onChange={(e) => setSelectedInstructor((prev) => ({ ...prev, phone: e.target.value }))} type="tel" label="Phone number" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={selectedInstructor.email} onChange={(e) => setSelectedInstructor((prev) => ({ ...prev, email: e.target.value }))} type="email" label="Email address" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={selectedInstructor.speciality} onChange={(e) => setSelectedInstructor((prev) => ({ ...prev, speciality: e.target.value }))} type="text" label="Speciality" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={selectedInstructor.bio} onChange={(e) => setSelectedInstructor((prev) => ({ ...prev, bio: e.target.value }))} label="Biography" multiline rows={6} style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={selectedInstructor.avialability} onChange={(e) => setSelectedInstructor((prev) => ({ ...prev, avialability: e.target.value }))} type="text" label="Days Available e.g. Tuesday, Thursday" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={selectedInstructor.hourly_rate} onChange={(e) => setSelectedInstructor((prev) => ({ ...prev, hourly_rate: e.target.value }))} type="text" label="Hours a day" style={{ marginBottom: 10 }} />
                        <FormLabel>Upload Image file</FormLabel>
                        <TextField variant="outlined" fullWidth onChange={(e) => handleFileUpload(e)} type="file" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={selectedInstructor.instagram} onChange={(e) => setSelectedInstructor((prev) => ({ ...prev, instagram: e.target.value }))} type="text" label="Instgram" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={selectedInstructor.facebook} onChange={(e) => setSelectedInstructor((prev) => ({ ...prev, facebook: e.target.value }))} type="text" label="Facebook" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={selectedInstructor.twitter} onChange={(e) => setSelectedInstructor((prev) => ({ ...prev, twitter: e.target.value }))} type="text" label="Twitter" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={selectedInstructor.whatsapp} onChange={(e) => setSelectedInstructor((prev) => ({ ...prev, whatsapp: e.target.value }))} type="text" label="Whatsap" style={{ marginBottom: 10 }} />
                    </div>
                    <div className="flex items-center justify-center gap-8 w-[90%] mx-auto mt-4">
                        <Button onClick={() => setIsEditModalOpen(false)} color="secondary" fullWidth variant="outlined">
                            Cancel
                        </Button>
                        <Button color="primary" fullWidth variant="outlined" onClick={handleEditInstructor}>
                            Save
                        </Button>
                    </div>
                </div>
            </Modal>

            {/* Add Member Modal */}
            <Modal open={isAddModalOpen} onClose={() => setIsAddModalOpen(false)} className="flex justify-center items-center" aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div className='bg-white w-[90%] lg:w-[40%] shadow p-8 rounded-sm h-[90%] overflow-y-auto'>
                    <h2 className="text-blue-950 mb-6">Add Instructor</h2>
                    <div>
                        <TextField variant="outlined" fullWidth value={instructor.name} onChange={(e) => setInstructor((prev) => ({ ...prev, name: e.target.value }))} type="text" label="Entet name of instructor" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={instructor.phone} onChange={(e) => setInstructor((prev) => ({ ...prev, phone: e.target.value }))} type="tel" label="Phone number" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={instructor.email} onChange={(e) => setInstructor((prev) => ({ ...prev, email: e.target.value }))} type="email" label="Email address" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={instructor.speciality} onChange={(e) => setInstructor((prev) => ({ ...prev, speciality: e.target.value }))} type="text" label="Speciality" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={instructor.bio} onChange={(e) => setInstructor((prev) => ({ ...prev, bio: e.target.value }))} label="Biography" multiline rows={6} style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={instructor.avialability} onChange={(e) => setInstructor((prev) => ({ ...prev, avialability: e.target.value }))} type="text" label="Days Available e.g. Tuesday, Thursday" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={instructor.hourly_rate} onChange={(e) => setInstructor((prev) => ({ ...prev, hourly_rate: e.target.value }))} type="text" label="Hours a day" style={{ marginBottom: 10 }} />
                        <FormLabel>Upload Image file</FormLabel>
                        <TextField variant="outlined" fullWidth onChange={(e) => handleFileUpload(e)} type="file" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={instructor.instagram} onChange={(e) => setInstructor((prev) => ({ ...prev, instagram: e.target.value }))} type="text" label="Instgram" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={instructor.facebook} onChange={(e) => setInstructor((prev) => ({ ...prev, facebook: e.target.value }))} type="text" label="Facebook" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={instructor.twitter} onChange={(e) => setInstructor((prev) => ({ ...prev, twitter: e.target.value }))} type="text" label="Twitter" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={instructor.whatsapp} onChange={(e) => setInstructor((prev) => ({ ...prev, whatsapp: e.target.value }))} type="text" label="Whatsap" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={instructor.password} onChange={(e) => setInstructor((prev) => ({ ...prev, password: e.target.value }))} type="password" label="password" style={{ marginBottom: 10 }} />
                    </div>
                    <div className="flex items-center justify-center gap-8 w-[90%] mx-auto mt-4">
                        <Button onClick={() => setIsAddModalOpen(false)} color="secondary" variant="outlined" fullWidth>
                            Cancel
                        </Button>
                        <Button color="primary" variant="outlined" fullWidth onClick={handleAddInstructor}>
                            Save
                        </Button>
                    </div>
                </div>
            </Modal>

            {/* Add schedule Modal */}
            <Modal open={isSchedulerOpen} className="flex justify-center items-center" aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div className='bg-white w-[90%] lg:w-[70%] shadow p-8 rounded-sm h-[60%] overflow-y-auto'>
                    <div className="flex justify-between">
                        <h2 className="text-blue-950 mb-6">Add schedule</h2>
                        <Button onClick={() => setIsSchedulerOpen(false)} color="error" variant="outlined">
                            <Cancel />
                        </Button>
                    </div>
                    <Button onClick={() => setIsAddScheduleOpen(true)} color="success" variant="outlined">
                        <AddBox /> {"  "} Add schedule
                    </Button>
                    <TableContainer component={Paper} className="shadow mt-4" sx={{ color: "#1f2937", overflowX: "auto" }}>
                        <Table sx={{ minWidth: 650 }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell></TableCell>
                                    <TableCell>Day</TableCell>
                                    <TableCell>Exercise</TableCell>
                                    <TableCell>Start time</TableCell>
                                    <TableCell>End Time</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Created At</TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {schedules.length > 0 ?
                                    (schedules.map((schedule, index) =>
                                        <TableRow key={index}>
                                            <TableCell className="text-center">{index + 1}</TableCell>
                                            <TableCell className="text-center">{schedule.day}</TableCell>
                                            <TableCell className="text-center">{schedule.exercise}</TableCell>
                                            <TableCell className="text-center">{schedule.start_time} {[12,13,14,15,16,17,18,19,20,21,22,23].includes(schedule.start_time.slice(0,2)) ? 'PM' : 'AM'}</TableCell>
                                            <TableCell className="text-center">{schedule.end_time} {[12,13,14,15,16,17,18,19,20,21,22,23].includes(schedule.start_time.slice(0,2)) ? 'PM' : 'AM'}</TableCell>
                                            <TableCell className="text-center">{schedule.status === 1 ? "Active" : "Inactive"}</TableCell>
                                            <TableCell className="text-center">{schedule.createdAt.slice(0, 10)}</TableCell>
                                            <TableCell className="text-center">
                                                <Button onClick={() => handleEditScheduleOpener(schedule)}><Edit color="primary" /></Button>
                                                <Button onClick={() => handleDeleteScheduleOpener(schedule)}><Delete color="error" /></Button>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                :
                                    <TableRow><TableCell colSpan={8} className="text-center">No schedules found.</TableCell></TableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {/* <DataGrid paginationModel={paginationModel} onPaginationModelChange={setPaginationModel} {...data} loading={loading} /> */}
                </div>
            </Modal>

            {/* Add Schedule Modal */}
            <Modal open={isAddScheduleOpen} onClose={() => setIsAddScheduleOpen(false)} className="flex justify-center items-center" aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div className='bg-white w-[90%] lg:w-[40%] shadow p-8 rounded-sm'>
                    <h2 className="text-blue-950 mb-6"> Add Instructor schedule</h2>
                    <div>
                        <TextField variant="outlined" fullWidth value={schedule.day} onChange={(e) => setSchedule((prev) => ({ ...prev, day: e.target.value }))} type="text" label="Enter Day" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={schedule.exercise} onChange={(e) => setSchedule((prev) => ({ ...prev, exercise: e.target.value }))} type="text" label="Enter exercise" style={{ marginBottom: 10 }} />
                        <FormLabel>Start time</FormLabel>
                        <TextField variant="standard" fullWidth value={schedule.start_time} onChange={(e) => setSchedule((prev) => ({ ...prev, start_time: e.target.value }))} type="time" style={{ marginBottom: 10 }} />
                        <FormLabel>End time</FormLabel>
                        <TextField variant="standard" fullWidth value={schedule.end_time} onChange={(e) => setSchedule((prev) => ({ ...prev, end_time: e.target.value }))} type="time" style={{ marginBottom: 10 }} />
                        <Checkbox checked={schedule.status} onChange={() => setSchedule((prev) => ({ ...prev, status: !prev.status }))} />
                        <FormLabel>Status</FormLabel>
                    </div>
                    <div className="flex items-center justify-center gap-8 w-[90%] mx-auto mt-4">
                        <Button onClick={() => setIsAddScheduleOpen(false)} color="secondary" variant="outlined" fullWidth>
                            Cancel
                        </Button>
                        <Button color="primary" variant="outlined" fullWidth onClick={handleAddToInstructorSchedule}>
                            Save
                        </Button>
                    </div>
                </div>
            </Modal>

            {/* Edit Schedule Modal */}
            <Modal open={isEditScheduleOpen} onClose={() => setIsEditScheduleOpen(false)} className="flex justify-center items-center" aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div className='bg-white w-[90%] lg:w-[40%] shadow p-8 rounded-sm'>
                    <h2 className="text-blue-950 mb-6"> Edit Instructor schedule</h2>
                    <div>
                        <TextField variant="outlined" fullWidth value={selectedSchedule.day} onChange={(e) => setSelectedSchedule((prev) => ({ ...prev, day: e.target.value }))} type="text" label="Enter Day" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={selectedSchedule.exercise} onChange={(e) => setSelectedSchedule((prev) => ({ ...prev, exercise: e.target.value }))} type="text" label="Enter exercise" style={{ marginBottom: 10 }} />
                        <FormLabel>Start time</FormLabel>
                        <TextField variant="standard" fullWidth value={selectedSchedule.start_time} onChange={(e) => setSelectedSchedule((prev) => ({ ...prev, start_time: e.target.value }))} type="time" style={{ marginBottom: 10 }} />
                        <FormLabel>End time</FormLabel>
                        <TextField variant="standard" fullWidth value={selectedSchedule.end_time} onChange={(e) => setSelectedSchedule((prev) => ({ ...prev, end_time: e.target.value }))} type="time" style={{ marginBottom: 10 }} />
                        <Checkbox checked={selectedSchedule.status} onChange={() => setSelectedSchedule((prev) => ({ ...prev, status: !prev.status }))} />
                        <FormLabel>Status</FormLabel>
                    </div>
                    <div className="flex items-center justify-center gap-8 w-[90%] mx-auto mt-4">
                        <Button onClick={() => setIsEditScheduleOpen(false)} color="secondary" variant="outlined" fullWidth>
                            Cancel
                        </Button>
                        <Button color="primary" variant="outlined" fullWidth onClick={handleEditToInstructorSchedule}>
                            Save
                        </Button>
                    </div>
                </div>
            </Modal>

            {/* Delete Confirmation Modal */}
            <Dialog open={isDeleteScheduleOpen} onClose={() => setIsDeleteScheduleOpen(false)}>
                <DialogTitle className="text-blue-950">Delete Confirmation</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this schedule?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsDeleteScheduleOpen(false)} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleDeleteSchedule} color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar open={open} autoHideDuration={10000} onClose={() => setOpen(false)} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                <Alert color={message.startsWith("Success") ? 'success' : message.startsWith('Failure') ? 'error' : message.startsWith('Warning') ? 'warning' : 'info'}>{message}</Alert>
            </Snackbar>
        </div>
    )
}

export default Instructors